import styled from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';
import { Cell as RowCell } from './TableRow/TableRow.styles';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`;

export const Cell = styled(RowCell)`
	font-size: 11px;
	line-height: 13px;
	color: ${colors.grey5};
	cursor: default;
	height: 40px;
`;

export const CellNumber = styled(Cell)`
	text-align: center;
	justify-content: center;
	min-width: 156px;
	max-width: 156px;
`;

export const CellNumberCheckbox = styled(CellNumber)`
	min-width: 168px;
	max-width: 168px;
	line-height: 12px;
`;

export const NoData = styled.div`
	padding: 8px 24px;
`;

export const SortArrow = styled(ApIcon)`
	margin-left: 5px;
	transform: ${({ reverse }) => (reverse ? 'rotate(90deg)' : 'rotate(-90deg)')};
`;

export const SortIconSpace = styled.div`
	min-width: 18px;
`;

export const CheckboxWrapper = styled.div`
	padding-right: 16px;
`;

export const HeaderCellWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	width: 100%;
`;

export const HeaderScrollWrapper = styled.div`
	width: 100%;
	min-height: 40px;
	border-bottom: 1px solid ${colors.grey3};
	overflow: hidden;
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	overflow: hidden;
`;

export const SpanColumn = styled.div`
	display: flex;
	align-items: center;
	border-right: 1px solid ${colors.grey2};
	height: 100%;
	min-width: 64px;
	max-width: 64px;

	&:last-child {
		border-right: none;
	}

	${({ noBorder }) => noBorder && 'border-right: none;'};
`;

export const SpanWrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-right: 1px solid ${colors.grey2};

	${SpanColumn} {
		${({ isGroup }) => isGroup && 'padding-top: 12px;'};
	}
`;

export const RowSpan = styled.div`
	display: flex;
	align-items: center;
	font-size: 11px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	height: 100%;
	border-bottom: 1px solid ${colors.grey2};

	&:last-child {
		border-bottom: none;
	}
`;

export const HeaderText = styled.div`
	width: 100%;
	text-align: center;
	font-size: 11px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	padding: 0 4px;
`;

export const CellText = styled.div`
	color: ${colors.grey5};
	text-align: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	width: 100%;
`;
